import React, { useState } from 'react';
import Button from '../../components/Button';
import Input from '../../components/Input';

interface EditPDFFileNameProps {
  handlepopup: (show: boolean) => void;
  editFormData: {
    pdfName: string;
    pdfId: any;
    isSubmitting: boolean;
    validationError: string;
  };
  updatePdfName: (newName: string) => void;
  validateAndSubmitEdit: () => Promise<boolean>;
}

const EditPDFFileName = ({
  handlepopup,
  editFormData,
  updatePdfName,
  validateAndSubmitEdit,
}: EditPDFFileNameProps) => {
  const [isShowPopUp, setIsShowPopUp] = useState<boolean>(true);

  const handleFilename = (e: React.ChangeEvent<HTMLInputElement>): void => {
    updatePdfName(e.target.value);
  };

  const close = (): void => {
    setIsShowPopUp(false);
    handlepopup(false);
  };

  const handleSubmit = async (): Promise<void> => {
    const success = await validateAndSubmitEdit();
    if (success) {
      close();
    }
  };

  if (!isShowPopUp) {
    return null;
  }

  return (
    <div className="modalContainer">
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <header className="modal_header">
          <h2 className="modal_header-title" style={{ textAlign: 'left' }}>
            PDF Export Name
          </h2>
          <button
            className="filters_modal_close_icon"
            onClick={close}
            type="button"
            aria-label="Close modal"
            disabled={editFormData.isSubmitting}
          >
            <svg
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M13.96 12.75L19.5 18.29V19.75H18.04L12.5 14.21L6.96 19.75H5.5V18.29L11.04 12.75L5.5 7.21V5.75H6.96L12.5 11.29L18.04 5.75H19.5V7.21L13.96 12.75Z"
                fill="black"
              />
            </svg>
          </button>
        </header>
        <main className="modal_content">
          <Input
            value={editFormData.pdfName}
            label="File Name"
            onChange={handleFilename}
            placeholder="File Name"
            block
            errors={editFormData.validationError}
            disabled={editFormData.isSubmitting}
          />
        </main>
        <footer className="modal_footer">
          <Button
            color="teal"
            size="small"
            onClick={handleSubmit}
            label={editFormData.isSubmitting ? 'Updating...' : 'Submit'}
            disabled={
              !editFormData.pdfName ||
              editFormData.pdfName.length === 0 ||
              editFormData.isSubmitting
            }
          />
        </footer>
      </div>
    </div>
  );
};

export default EditPDFFileName;
